<script setup lang="ts">
import { VueFinalModal } from "vue-final-modal";

defineProps<{
  title?: string;
  bonus?: string;
  button?: string;
  spins?: number;
  link?: string;
}>();

const emit = defineEmits<{
  (e: "confirm"): void;
}>();

const spinClass = localStorage.getItem("currentSpin");
</script>

<template>
  <VueFinalModal :clickToClose="false" :escToClose="false">
    <span class="counter-spin">{{ $t("modals.counter_spin") }} {{ spins }}</span>
    <h1 class="text-xl">
      {{ title }}
    </h1>
    <div class="bonus">{{ bonus }}</div>
    <a class="btn" :href="link" target="_blank" @click="emit('confirm')">
      <span class="star-modal">
        <svg
          width="49"
          height="50"
          viewBox="0 0 49 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.0872 40.0453C25.4514 40.0453 24.8156 39.7274 24.1798 39.0916L19.0934 32.4156L11.1458 32.7335C10.1921 32.7335 9.55633 32.4156 9.23843 31.4619C8.92052 30.8261 8.92052 29.8724 9.23843 29.2366L14.0069 22.5607L11.1458 14.931C10.8279 14.2952 11.1458 13.3415 11.4637 12.7057C12.0995 12.0699 13.0532 11.752 13.6891 12.0699L21.6366 14.6131L28.3125 9.52672C28.9483 8.89091 29.902 8.89091 30.5378 9.20881C31.1736 9.52672 31.8094 10.4804 31.8094 11.1162V19.3817L38.8032 24.1502C39.4391 24.4681 39.757 25.4218 39.757 26.3755C39.757 27.3292 39.1212 27.965 38.1675 28.2829L30.2199 30.8261L27.9946 38.7737C27.6767 39.7274 27.0409 40.0453 26.4051 40.3632C26.4051 40.0453 26.4051 40.0453 26.0872 40.0453ZM20.6829 27.965C21.3187 27.965 21.9545 28.2829 22.5903 28.9187L25.4514 33.0514L26.723 28.2829C27.0409 27.6471 27.3588 27.0113 27.9946 26.6934L32.7631 25.1039L28.6304 22.2428C27.9946 21.9249 27.6767 21.2891 27.6767 20.3354V15.2489L23.8619 18.428C23.2261 18.7459 22.5903 19.0638 21.9545 18.7459L16.8681 17.4743L18.4576 22.2428C18.7755 22.8786 18.4576 23.8323 18.1397 24.1502L15.2786 28.2829L20.6829 27.965Z"
            fill="#FFFB40"
          />
          <g filter="url(#filter0_f_69_8279)">
            <path
              d="M26.0872 40.0453C25.4514 40.0453 24.8156 39.7274 24.1798 39.0916L19.0934 32.4156L11.1458 32.7335C10.1921 32.7335 9.55633 32.4156 9.23843 31.4619C8.92052 30.8261 8.92052 29.8724 9.23843 29.2366L14.0069 22.5607L11.1458 14.931C10.8279 14.2952 11.1458 13.3415 11.4637 12.7057C12.0995 12.0699 13.0532 11.752 13.6891 12.0699L21.6366 14.6131L28.3125 9.52672C28.9483 8.89091 29.902 8.89091 30.5378 9.20881C31.1736 9.52672 31.8094 10.4804 31.8094 11.1162V19.3817L38.8032 24.1502C39.4391 24.4681 39.757 25.4218 39.757 26.3755C39.757 27.3292 39.1212 27.965 38.1675 28.2829L30.2199 30.8261L27.9946 38.7737C27.6767 39.7274 27.0409 40.0453 26.4051 40.3632C26.4051 40.0453 26.4051 40.0453 26.0872 40.0453ZM20.6829 27.965C21.3187 27.965 21.9545 28.2829 22.5903 28.9187L25.4514 33.0514L26.723 28.2829C27.0409 27.6471 27.3588 27.0113 27.9946 26.6934L32.7631 25.1039L28.6304 22.2428C27.9946 21.9249 27.6767 21.2891 27.6767 20.3354V15.2489L23.8619 18.428C23.2261 18.7459 22.5903 19.0638 21.9545 18.7459L16.8681 17.4743L18.4576 22.2428C18.7755 22.8786 18.4576 23.8323 18.1397 24.1502L15.2786 28.2829L20.6829 27.965Z"
              fill="#FFFB40"
            />
          </g>
          <defs>
            <filter
              id="filter0_f_69_8279"
              x="0"
              y="0"
              width="48.7568"
              height="49.3633"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4.5"
                result="effect1_foregroundBlur_69_8279"
              />
            </filter>
          </defs>
        </svg>
      </span>
      <span class="content">
        {{ button }}
      </span>
    </a>
  </VueFinalModal>
</template>

<style lang="scss">
@import "@/scss/variables.scss";
@import "@/scss/mixins.scss";

.vfm {
  &__overlay {
    backdrop-filter: blur(0px);
    animation: backgroundChange 3s ease-in-out infinite;
    background: rgba(4, 8, 28, 0.9) url("@/img/modal/bg-320.svg") no-repeat
      center;

    @include media-breakpoint("430") {
      background-size: 361px 222px;
    }

    @media (min-width: 780px) and (max-width: 970px) and (min-height: 360px) and (max-height: 490px) and (orientation: landscape) {
      background-size: 447px 274px;
    }

    @include media-breakpoint("1020") {
      background-size: 553px 340px;
    }

    @include media-breakpoint("1366") {
      background-size: 701px 431px;
    }

    @include media-breakpoint("1920") {
      background-size: 874px 537px;
    }
  }

  &__content {
    padding-top: 15px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 200px;
    height: 145px;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: top;
    white-space: pre-line;
    text-align: center;
    font-style: normal;

    @media (min-width: 780px) and (max-width: 970px) and (min-height: 360px) and (max-height: 490px) and (orientation: landscape) {
      width: 277px;
      padding-top: 0;
    }

    @include media-breakpoint("1020") {
      justify-content: center;
      width: 530px;
      height: 380px;
      padding: 0;
    }

    .counter-spin {
      position: absolute;
      top: calc(-50vh + 50% + 40px);
      text-align: center;
      text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.12);
      font-size: 18px;
      font-weight: 700;
      line-height: 130%;
      white-space: nowrap;

      @media (min-width: 780px) and (max-width: 970px) and (min-height: 360px) and (max-height: 490px) and (orientation: landscape) {
        font-size: 20px;
        top: calc(-50vh + 50% + 30px);
        width: 100%;
        left: 115%;
      }

      @include media-breakpoint("1020") {
        top: calc(-50vh + 50% + 40px);
        width: 100%;
        left: 70%;
        font-size: 20px;
      }

      @include media-breakpoint("1366") {
        left: 104%;
      }

      @include media-breakpoint("1920") {
        font-size: 24px;
        left: 150%;
      }
    }

    h1.text-xl {
      font-size: 18px;
      font-weight: 600;
      line-height: 100%;
      margin: 5px 0 10px;

      @include media-breakpoint("430") {
        font-size: 20px;
      }

      @media (min-width: 780px) and (max-width: 970px) and (min-height: 360px) and (max-height: 490px) and (orientation: landscape) {
        font-size: 30px;
        margin-top: -10px;
      }

      @include media-breakpoint("1020") {
        font-size: 32px;
        line-height: 100%;
      }

      @include media-breakpoint("1366") {
        font-size: 44px;
        margin-top: 0;
      }
      @include media-breakpoint("1920") {
        margin-bottom: 20px;
      }
    }

    .bonus {
      font-size: 22px;
      font-weight: 900;
      line-height: 130%;
      padding-bottom: 2px;
      white-space: nowrap;

      @include media-breakpoint("430") {
        font-size: 24px;
        margin-bottom: 2px;
      }

      @media (min-width: 780px) and (max-width: 970px) and (min-height: 360px) and (max-height: 490px) and (orientation: landscape) {
        font-size: 40px;
        margin-bottom: 0;
        padding-bottom: 0;
      }

      @include media-breakpoint("1020") {
        font-size: 42px;
        line-height: 130%;
      }

      @include media-breakpoint("1366") {
        font-size: 60px;
      }

      @include media-breakpoint("1920") {
        padding-bottom: 10px;
      }
    }

    .btn {
      min-width: 115px;
      max-width: 400px;
      height: 40px;
      background: url("@/img/modal/button-sm.webp") no-repeat center;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 8px 16px;
      box-sizing: border-box;
      cursor: pointer;
      text-decoration: none;

      @media (min-width: 780px) and (max-width: 970px) and (min-height: 360px) and (max-height: 490px) and (orientation: landscape) {
        min-width: 160px;
        min-height: 50px;
        column-gap: 8px;
        padding: 16px 20px;
      }

      @include media-breakpoint("1020") {
        background: url("@/img/modal/button-lg.webp") no-repeat center;
        background-size: 100% 100%;
        min-width: 210px;
        max-width: 590px;
        height: 56px;
        padding: 20px 25px;
        column-gap: 4px;
      }

      @include media-breakpoint("1366") {
        min-width: 210px;
        max-width: 600px;
        height: 68px;
        padding: 20px 30px;
        column-gap: 4px;
      }

      @include media-breakpoint("1920") {
        min-width: 280px;
        height: 90px;
      }

      .star-modal {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        svg {
          width: 16px;
          height: 16px;
          flex-shrink: 0;
          margin-left: -10px;

          @media (min-width: 780px) and (max-width: 970px) and (min-height: 360px) and (max-height: 490px) and (orientation: landscape) {
            width: 36px;
            height: 36px;
          }

          @include media-breakpoint("1020") {
            width: 38px;
            height: 38px;
          }

          @include media-breakpoint("1366") {
            width: 40px;
            height: 40px;
          }

          @include media-breakpoint("1920") {
            width: 44px;
            height: 44px;
          }
        }
      }

      .content {
        font-size: 8px;
        font-weight: 700;
        line-height: 130%;
        text-transform: uppercase;
        flex-shrink: 1;
        display: flex;
        align-items: center;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: wrap;
        max-width: 100%;

        @media (min-width: 780px) and (max-width: 970px) and (min-height: 360px) and (max-height: 490px) and (orientation: landscape) {
          font-size: 14px;
          margin-left: -10px;
        }

        @include media-breakpoint("1020") {
          font-size: 18px;
          padding-top: 4px;
        }

        @include media-breakpoint("1366") {
          font-size: 20px;
          padding-top: 2px;
        }

        @include media-breakpoint("1920") {
          font-weight: 600;
        }
      }
    }
  }
}
</style>
